import React, { useState } from "react";
import axios from 'axios';
import { getApiUrl, RAZORPAY_KEY } from "../../config";
import "./ProductCard.css";

const products = [
  {
    id: 4,
    title: "Food Packets (20 Kids)",
    price: 700,
    kids: 20,
    description: "Sponsor nutritious meals for 20 underprivileged children and receive video wishes as a token of their gratitude and joy.",
    image: "/images/FOOD PACKETS.jpg"
  },
  {
    id: 2,
    title: "Food Packet & Cake",
    price: 1400,
    kids: 20,
    description: "Sponsor 20 nutritious meals and a delicious cake for underprivileged children. You'll receive video wishes from the kids to brighten your day.",
    image: "/images/FOOD AND CAKE.jpg"
  },
  {
    id: 3,
    title: "Mini Party",
    price: 2000,
    kids: 20,
    description: "Provide 20 meals and a cake for children in need, with your name featured on our celebration banner. Includes heartwarming video wishes.",
    image: "/images/MINI PARTY.jpg"
  },
  {
    id: 1,
    title: "Grand Party",
    price: 5000,
    kids: 20,
    description: "A full-package birthday celebration with 20 nutritious meals, a 3 kg cake, your name on the celebration banner, and heartwarming video wishes from the children.",
    image: "/images/GRAND PARTY.jpg"
  }
];

function ProductCard({ product }) {
  const [quantity, setQuantity] = useState(1);
  const [loading, setLoading] = useState(false);

  const handleIncrement = () => setQuantity(prev => prev + 1);
  const handleDecrement = () => setQuantity(prev => (prev > 1 ? prev - 1 : 1));

  const handleDonateClick = async () => {
    setLoading(true);
    try {
      // Create request data
      const requestData = {
        order_amount: product.price * quantity,
        order_currency: "INR",
        customer_details: {
          customer_email: "",
          customer_phone: "",
          customer_name: "",
        },
        order_meta: {
          product_name: product.title,
          product_id: product.id,
          kids_helped: product.kids * quantity,
          return_url: window.location.origin + "/thankYou"
        }
      };
      
      // Call API to create subscription
      const response = await axios.post(
        getApiUrl("/api/oneTime/createOrder"),
        requestData
      );
      
      // Save order info to session storage
      sessionStorage.setItem("orderId", response.data.order_id);
      sessionStorage.setItem("order_amount", product.price * quantity);
      sessionStorage.setItem("order_currency", "INR");
      sessionStorage.setItem("product_name", product.title);
      sessionStorage.setItem("kids_helped", product.kids * quantity);
      
      // Create Razorpay options
      const options = {
        key: RAZORPAY_KEY,
        amount: product.price * quantity * 100, // Razorpay expects amount in paise
        currency: "INR",
        name: 'Sood Charity Foundation',
        description: `${product.title} - ${product.kids * quantity} Kids`,
        order_id: response.data.order_id, 
        handler: async function(razorpayResponse) {
          // Successful payment handler
          console.log('Payment successful:', razorpayResponse);
          
          try {
            // Call backend API to save order and send emails
            const orderData = {
              razorpay_payment_id: razorpayResponse.razorpay_payment_id,
              razorpay_order_id: razorpayResponse.razorpay_order_id,
              razorpay_signature: razorpayResponse.razorpay_signature,
              product_id: product.id,
              product_name: product.title,
              quantity: quantity,
              amount: product.price * quantity,
              kids_helped: product.kids * quantity
            };

            await axios.post(
              getApiUrl('/api/celebration/completeOrder'),
              orderData
            );
            
            console.log('Order saved and emails sent successfully');
          } catch (error) {
            console.error('Error saving celebration order:', error);
            // Continue with redirect even if API call fails
          }
          
          // Redirect to thank you page with order details
          window.location.href = `/thankYou/${razorpayResponse.razorpay_order_id}`;
        },
        modal: {
          ondismiss: function() {
            console.log('Payment modal closed');
            setLoading(false);
          }
        },
        prefill: {
          name: '',
          email: '',
          contact: ''
        },
        theme: {
          color: '#00345B',
        },
        method: {
          netbanking: true,
          card: true,
          upi: true,
          wallet: true
        },
        notes: {
          product_name: product.title,
          kids_helped: product.kids * quantity
        }
      };
      
      // Open Razorpay
      const rzp = new window.Razorpay(options);
      rzp.on('payment.failed', function(response) {
        console.error('Payment failed:', response.error);
        alert(`Payment failed: ${response.error.description}`);
        setLoading(false);
      });
      
      rzp.open();
      
    } catch (error) {
      console.error('Donation error:', error);
      alert('Failed to process donation. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="product-card">
      <div className="product-header">
        <div className="product-image-container">
          <img src={product.image} alt={product.title} className="product-image" />
        </div>
        <h3 className="product-title">{product.title}</h3>
      </div>
      
      <div className="product-content">
        <p className="product-price">₹{(product.price * quantity).toLocaleString()} for {product.kids * quantity} Kids</p>
        
        <div className="quantity-selector">
          <button 
            onClick={handleDecrement} 
            className="quantity-btn"
            aria-label="Decrease quantity"
          >−</button>
          <span className="quantity-display">{quantity}</span>
          <button 
            onClick={handleIncrement} 
            className="quantity-btn"
            aria-label="Increase quantity"
          >+</button>
        </div>
        
        <p className="product-description">{product.description}</p>
        
        <button 
          onClick={handleDonateClick} 
          className="donate-btn"
          disabled={loading}
          aria-label={`Donate ₹${(product.price * quantity).toLocaleString()} now`}
        >
          {loading ? 'Processing...' : `DONATE NOW | ₹${(product.price * quantity).toLocaleString()}`}
        </button>
      </div>
    </div>
  );
}

function ProductsSection() {
  return (
    <div className="products-section">
      <div className="products-container">
        <h2 className="products-title">Celebration Packages</h2>
        <p className="products-subtitle">Choose a package to bring joy to children in need</p>
        <div className="products-grid">
          {products.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default ProductsSection;
